import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import styles from "./Subsection.module.scss";
import useIsDesktop from "hooks/useIsDesktop";
import wrapperHOC from "@Utils/wrapperHOC";

type SubsectionProps = {
  title?: string;
  subtitle?: string;
  children: any;
  withSidePadding?: boolean;
  greyBg?: boolean;
  titleH2?: boolean;
};

const Subsection = ({
  title,
  subtitle,
  children,
  withSidePadding = true,
  greyBg = false,
  titleH2 = false,
}: SubsectionProps) => {
  const isDesktop = useIsDesktop();

  return (
    <div
      className={formatClassNames(
        withSidePadding ? styles.subsectionContainer : styles.subSectionContainerNoPadding,
        greyBg ? styles.bgColor : {},
        styles.paddingForScholarshipPage,
      )}
    >
      {(title || subtitle) && (
        <div className={withSidePadding ? styles.header : styles.headerWithPadding}>
          {title &&
            (titleH2 ? (
              <h2 className={isDesktop ? styles.title : styles.titleMobile}>{title}</h2>
            ) : (
              <h4 className={isDesktop ? styles.title : styles.titleMobile}>{title}</h4>
            ))}
          {subtitle && (
            <h5 className={isDesktop ? styles.subtitle : styles.subtitleMobile}>{subtitle}</h5>
          )}
        </div>
      )}
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default wrapperHOC(Subsection, {
  componentName: "Subsection-Scholarship",
  showForChina: true,
});
